import React, { useState } from "react";
import "./Card.css";
import CreatorAvatars from "../../CreatorAvatars";
import { CardProps } from "./types";

export const CardArtist: React.FC<CardProps> = ({
  imageUrls,
  title,
  type,
  typeColor = "#6b7280",
  onClick,
  selected = false,
  children,
  creators = [],
  layoutType,
}) => {
  const [hovered, setHovered] = useState(false);
  const image = imageUrls && imageUrls.length > 0 ? imageUrls[0] : null;
  const uncroppedImage = image ? removeCropFromCloudinaryUrl(image) : null;

  // CLASSES
  const hoverClass = hovered ? "card--hovered" : "";
  const selectedClass = selected ? "card--selected" : "";

  return (
    <div
      className={`card ${selectedClass} card--artist ${hoverClass}`}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {uncroppedImage && (
        <div className={`card__image-container card__image-container--artist`}>
          <img
            src={uncroppedImage}
            alt={title}
            className="card__image"
            onError={(e) => {
              (e.target as HTMLImageElement).style.display = "none";
            }}
          />
        </div>
      )}
      <div>
        <span
          className={`card__image-caption ${hovered ? "card__image-caption--hover" : ""}`}
        >
          {title}
        </span>
      </div>
    </div>
  );
};

// Quick hack to remove crop from url
// E.g. https://res.cloudinary.com/dreamcloud-media/image/upload/c_crop,x_0,y_0,w_1000,h_667/listings/covers/s3uqii4qhlksr2iymxyl.jpg ->
// https://res.cloudinary.com/dreamcloud-media/image/upload/w_1000/listings/covers/s3uqii4qhlksr2iymxyl.jpg
export const removeCropFromCloudinaryUrl = (url: string): string => {
  const noCrop = url.replace(/\/c_crop,[^/]+\//, "/");
  const noHeight = noCrop.replace(/\/h_[0-9]+,?/, "/");
  return noHeight;
};
